import { render, staticRenderFns } from "./TablesIcon.vue?vue&type=template&id=60730f74&"
import script from "./TablesIcon.vue?vue&type=script&lang=js&"
export * from "./TablesIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports